import { createElement } from "react";
import { RouteObject } from "react-router-dom";

import { makeRedirects } from "~/helpers/routes";

import { routes as app } from "~/router/routes/app";
import { routes as auth } from "~/router/routes/auth";
import { routes as settings } from "~/router/routes/settings";
import { routes as checkout } from "~/router/routes/checkout";
import { DISABLE_PAYMENTS } from "~/helpers/plans";

import RouteErrorBoundary from "~/components/layout/RouteErrorBoundary";

// Render crashes otherwise fall through to react-router's built-in error
// screen ("Unexpected Application Error!") — untranslated and unrecoverable.
// A route-level errorElement keeps the user on a branded page with a reload
// action and reports the crash to Datadog. Spread after errorElement so a
// route can still define its own boundary.
const withErrorBoundary = (route: RouteObject): RouteObject => ({
  errorElement: createElement(RouteErrorBoundary),
  ...route,
});

export const routes: RouteObject[] = [
  ...app,
  ...auth,
  ...settings,
  ...(DISABLE_PAYMENTS ? [] : checkout),
  ...makeRedirects(),
].map(withErrorBoundary);
